import axiosInstance from './axios';
import { PromoCodesParams, PromoCodesResponse, CreatePromoCodeRequest } from 'types/promoCode';
import { mapFilterParams } from 'utils/filter';

const filterFieldMap: Record<string, string> = {};

export const promoCodeService = {
  getPromoCodes: async (params: PromoCodesParams): Promise<PromoCodesResponse> => {
    const { page, limit, siteId, status, sortField, sortValue, ...rest } = params;
    const mappedParams = mapFilterParams(rest, filterFieldMap);

    const queryParams: any = {
      page,
      limit,
      sortField,
      sortValue,
      filters: '',
      ...mappedParams,
    };
    if (siteId !== undefined && siteId !== 'all') queryParams.siteId = siteId;
    if (status !== undefined && status !== 'all') queryParams.status = status;

    const response = await axiosInstance.get<PromoCodesResponse>('/admin/promo-codes', {
      params: queryParams,
    });
    return response.data;
  },

  createPromoCode: async (data: CreatePromoCodeRequest): Promise<any> => {
    const response = await axiosInstance.post('/admin/promo-codes', data);
    return response.data;
  },

  updatePromoCode: async (id: string, data: Partial<CreatePromoCodeRequest>): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/promo-codes/${id}`, data);
    return response.data;
  },

  deletePromoCode: async (id: string): Promise<any> => {
    const response = await axiosInstance.delete(`/admin/promo-codes/${id}`);
    return response.data;
  },

  getPromoCodeUsages: async (params: any): Promise<any> => {
    const response = await axiosInstance.get('/admin/promo-codes/usages', { params });
    return response.data;
  },
};
